module.exports = __webpack_public_path__ + "bm.012b04b78dff697d63ab.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/4x3/bm.svg
// module id = ../../../../flag-icon-css/flags/4x3/bm.svg
// module chunks = styles